<app-notification-alert-box
  [notificationMessage]="notificationMessage"
  [buttonStandardTitle]="'NOTIFICATION.CHILD_ADULT.REMOVE'"
  [buttonPrimaryTitle]="'NOTIFICATION.CHILD_ADULT.CORRECT'"
  [buttonPrimaryExtraClasses]="buttonPrimaryExtraClasses"
  [buttonStandardExtraClasses]="buttonStandardExtraClasses"
  [buttonStandardIsLoading]="buttonStandardIsLoading"
  (buttonStandardClickEmitter)="buttonStandardClickEmitter.emit()"
  (buttonPrimaryClickEmitter)="buttonPrimaryClickEmitter.emit()"
>
</app-notification-alert-box>
